export default "__VITE_ASSET__3671fe07__"